/* eslint-disable max-nested-callbacks */
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import withLayout from "../../../components/desktop/layout/component";
import querystring from "querystring";
import { Helmet } from "react-helmet-async";
import ErrorHandler from "../../../components/shared/with-error-handler";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.desktop";
import { LEAD_FORM, NUMBER } from "../../../constants/app-constants";
import { SELL_ONLINE_STEP_KEY } from "../../../constants/sell-online-constant";

const SellOnlineLeadStepContainer = loadable(() => import("../../../components/desktop/sell-online-lead-step-container"));

const Confirmation = ({
    history,
    fetchFAQConnect
}) => {
    const [bottomFaqs, setBottomFaqs] = useState([]);

    const recieveParams = () => {
        const { location: { search } } = history;
        return search && querystring.parse(search.replace(/\?/g, ""));
    };

    const faqPayload = {
        slug: "selling-your-car-to-cars24-nonsellonline"
    };

    const queryParams = recieveParams();

    useEffect(() => {
        if (!queryParams) {
            history.replace("/");
        }
    }, [history, queryParams]);

    useEffect(() => {
        fetchFAQConnect(faqPayload)
            .then(response => {
                const idx = response["business-order"].findIndex(element => element.includes("sell"));

                if (idx >= NUMBER.ZERO) {
                    const type = response["business-order"][idx];
                    const res = response[type];

                    const list = [];

                    res.forEach((item) => {
                        // eslint-disable-next-line max-nested-callbacks
                        item.content.forEach((faq, index) => {
                            list.push({
                                ...faq,
                                id: index + NUMBER.ONE
                            });
                        });
                    });

                    setBottomFaqs(list);
                }

            })
            .catch(() => { });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderConfirmationDetails = () => (
        <React.Fragment>
            <ErrorHandler>
                <SellOnlineLeadStepContainer
                    manualCurrentStep={SELL_ONLINE_STEP_KEY.INSPECTION_BOOKED}
                    stepsConfig={FUNNEL_CONFIG[LEAD_FORM.APPOINTMENT]}
                    faqs={bottomFaqs}
                    isConfirmationPage
                />
            </ErrorHandler>
        </React.Fragment>
    );

    const renderEditBookingForm = () => {
        return (
            <ErrorHandler>
                <SellOnlineLeadStepContainer
                    manualCurrentStep={SELL_ONLINE_STEP_KEY.RESCHEDULE}
                    stepsConfig={FUNNEL_CONFIG[LEAD_FORM.APPOINTMENT]}
                    faqs={bottomFaqs}
                />
            </ErrorHandler>
        );
    };

    const renderBookingFormOrConfirmationDetails = () => {
        return (
            !!queryParams && (
                "l" in queryParams &&
                ("e" in queryParams ? renderEditBookingForm(queryParams)
                    : renderConfirmationDetails(queryParams))
            )
        );
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>CARS24 | Thank you for choosing CARS24!</title>
                <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
            </Helmet>

            {renderBookingFormOrConfirmationDetails() || <Redirect to="/" />}
        </React.Fragment>
    );
};

Confirmation.propTypes = {
    history: PropTypes.object.isRequired,
    fetchFAQConnect: PropTypes.func
};

export default withLayout(Confirmation, true, false, false);
